import type { MatrixClient } from "matrix-js-sdk";

export const getEmployeeOrganizationPrefix = ({
  env,
  organization,
  site,
}: {
  env: string;
  organization: string;
  site?: string;
}) => {
  if (site) {
    return `employee-${organization}-${site.toLocaleLowerCase()}-${env}-`;
  }
  return `employee-${organization}-${env}-`;
};

export const getEmployeeRoomName = ({
  employeeId,
  env,
  organization,
  site,
}: {
  employeeId: string;
  env: string;
  organization: string;
  site?: string;
}) => {
  return `${getEmployeeOrganizationPrefix({ env, organization, site })}${employeeId}`;
};

export const getEmployeeRoomAlias = ({
  employeeId,
  env,
  matrixClient,
  organization,
  site,
}: {
  employeeId: string;
  env: string;
  matrixClient: MatrixClient | null;
  organization: string;
  site?: string;
}) => {
  return `#${getEmployeeRoomName({ employeeId, env, organization, site })}:${matrixClient?.getDomain()}`;
};

export const getPatientRoomAlias = ({
  patientId,
  matrixClient,
}: {
  patientId: string;
  matrixClient: MatrixClient | null;
}) => {
  return `#${patientId}:${matrixClient?.getDomain()}`;
};

export const isEmployeeRoomName = (roomName: string, organization: string) => {
  return roomName.startsWith(`employee-${organization}-`);
};

export const extractEmployeeIdFromRoomName = (
  roomName: string,
  env: string,
) => {
  const marker = `-${env}-`;
  const index = roomName.lastIndexOf(marker);
  if (index === -1) {
    return null;
  }
  return roomName.slice(index + marker.length);
};
